export type EntryErrorKind =
  'invalid' | 'expired' | 'inactive' | 'closed' | 'rate-limit' | 'offline' | 'unexpected';

interface ErrorWithResponse extends Error {
  data?: { errors?: Array<{ code?: string }>; message?: string };
  response?: { status?: number };
}

export function responseErrorCode(response: PublicFnbResponse): string | undefined {
  return response.errors?.find((error) => error.code?.startsWith('FNB_PUBLIC_'))?.code;
}

export function classifyEntryError(error: unknown): EntryErrorKind {
  const requestError = error as ErrorWithResponse;
  if (requestError.response?.status === 429) return 'rate-limit';
  if (typeof navigator !== 'undefined' && !navigator.onLine) return 'offline';

  const code = requestError.data?.errors?.[0]?.code;
  return classifyEntryCode(code);
}

export function classifyEntryCode(code?: string): EntryErrorKind {
  switch (code) {
    case 'FNB_PUBLIC_QR_EXPIRED':
    case 'FNB_PUBLIC_SESSION_EXPIRED':
      return 'expired';
    case 'FNB_PUBLIC_QR_INVALID':
    case 'FNB_PUBLIC_SESSION_INVALID':
      return 'invalid';
    case 'FNB_PUBLIC_STORE_INACTIVE':
      return 'inactive';
    case 'FNB_PUBLIC_STORE_CLOSED':
      return 'closed';
    case 'FNB_PUBLIC_RATE_LIMITED':
      return 'rate-limit';
    default:
      return 'unexpected';
  }
}
import type { PublicFnbResponse } from '@nexacore/api-clients/fnb/public';
